module.exports = "table, th, td {\r\n    border: 1px solid black;\r\n    border-collapse: collapse;\r\n    padding:5px;\r\n}\r\n\r\n@media print {\r\n    .print-page{\r\n      display:none;\r\n    }\r\n\r\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/Godown/request-app-records/request-app-records.component.css
// module id = ./src/app/Godown/request-app-records/request-app-records.component.css
// module chunks = main